"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.moveFile = moveFile;
exports.removeFile = removeFile;
exports.renameFile = renameFile;
exports.uploadFiles = uploadFiles;
exports.getFetchVideoFileByPlayerIdAttemptedAction = getFetchVideoFileByPlayerIdAttemptedAction;
exports.getFetchVideoFileByPlayerIdFailedAction = getFetchVideoFileByPlayerIdFailedAction;
exports.getFetchVideoFileByPlayerIdSuccessAction = getFetchVideoFileByPlayerIdSuccessAction;
exports.fetchVideoFileByPlayerId = fetchVideoFileByPlayerId;
exports.getSaveFileEditAttemptedAction = getSaveFileEditAttemptedAction;
exports.getSaveFileEditSuccessAction = getSaveFileEditSuccessAction;
exports.getSaveFileEditFailedAction = getSaveFileEditFailedAction;
exports.updateFileMeta = updateFileMeta;
exports.fetchFilesForNavigator = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var Actions = _interopRequireWildcard(require("FileManagerCore/actions/Files"));

var _validation = require("../utils/validation");

var _ActionTypes = require("FileManagerCore/actions/ActionTypes");

var _tracking = require("FileManagerCore/actions/tracking");

var _ActionTypes2 = require("./ActionTypes");

var VideoPlayersApi = _interopRequireWildcard(require("FileManagerCore/api/VideoPlayers"));

var FilesApi = _interopRequireWildcard(require("FileManagerCore/api/Files"));

var _Configuration = require("../selectors/Configuration");

var _Auth = require("FileManagerCore/selectors/Auth");

var _FloatingAlertStore = _interopRequireDefault(require("UIComponents/alert/FloatingAlertStore"));

var _notifications = require("FileManagerCore/utils/notifications");

var _Constants = require("../Constants");

var _InternalFileManagerFileAccess = require("FileManagerCore/enums/InternalFileManagerFileAccess");

var _network = require("../utils/network");

var _Actions = require("./Actions");

var _Shutterstock = require("./Shutterstock");

function moveFile(file, destination) {
  return function (dispatch) {
    dispatch(Actions.moveFile(file, destination));
    dispatch((0, _tracking.trackInteraction)('Manage Files', 'move'));
  };
}

function removeFile(file) {
  return function (dispatch) {
    dispatch(Actions.removeFile(file));
    dispatch((0, _tracking.trackInteraction)('Manage Files', 'delete'));
  };
}

function renameFile(file, newName) {
  return function (dispatch) {
    dispatch((0, _tracking.trackInteraction)('Manage Files', 'rename'));
    return dispatch(Actions.renameFile(file, newName));
  };
}

function uploadFiles(fileList, options) {
  return function (dispatch, getState) {
    var type = options.type;
    var files = Array.prototype.slice.call(fileList);
    var validator = (0, _validation.getValidator)(type);
    var validFiles = [];

    if (validator) {
      files.forEach(function (file) {
        if (validator(file)) {
          validFiles.push(file);
        }
      });
    } else {
      validFiles = files;
    }

    options.access = (0, _Configuration.getUploadedFileAccess)(getState());
    return dispatch(Actions.uploadFiles(validFiles, options)).then(function (response) {
      if (response && response.length && _InternalFileManagerFileAccess.HiddenInAppFileAccessList.indexOf(options.access) === -1 && (0, _Auth.getIsUngatedForSuccessAlert)(getState())) {
        if (options.type === _Constants.DrawerTypes.HUBL_VIDEO) {
          _FloatingAlertStore.default.addAlert((0, _notifications.getHublVideoUploadSuccessAlert)(validFiles.length));
        } else {
          _FloatingAlertStore.default.addAlert((0, _notifications.getFileUploadSuccessAlert)(options.access, validFiles.length, function () {
            dispatch((0, _tracking.trackInteraction)('Alert interaction', 'clicked-file-visibility-learn-more'));
          }));
        }
      }
    });
  };
}

function getFetchVideoFileByPlayerIdAttemptedAction() {
  return {
    type: _ActionTypes2.FETCH_FILE_FOR_EDITING_ATTEMPTED
  };
}

function getFetchVideoFileByPlayerIdFailedAction() {
  return {
    type: _ActionTypes2.FETCH_FILE_FOR_EDITING_FAILED,
    meta: {
      notification: {
        type: 'danger',
        titleText: _I18n.default.text('FileManagerCore.notifications.editVideo.error.title'),
        message: _I18n.default.text('FileManagerCore.notifications.editVideo.error.message')
      }
    }
  };
}

function getFetchVideoFileByPlayerIdSuccessAction(file) {
  return {
    type: _ActionTypes2.FETCH_FILE_FOR_EDITING_SUCCEEDED,
    file: file
  };
}

function fetchVideoFileByPlayerId(playerId) {
  return function (dispatch, getState, httpClient) {
    dispatch(getFetchVideoFileByPlayerIdAttemptedAction());
    VideoPlayersApi.fetchVideoFileByPlayerId(playerId, httpClient).then(function (resp) {
      dispatch(getFetchVideoFileByPlayerIdSuccessAction(resp.get(0)));
    }, function () {
      dispatch(getFetchVideoFileByPlayerIdFailedAction());
    }).done();
  };
}

function getSaveFileEditAttemptedAction() {
  return {
    type: _ActionTypes2.SAVE_FILE_EDIT_ATTEMPTED
  };
}

function getSaveFileEditSuccessAction(file) {
  return {
    type: _ActionTypes2.SAVE_FILE_EDIT_SUCCEEDED,
    file: file
  };
}

function getSaveFileEditFailedAction() {
  return {
    type: _ActionTypes2.SAVE_FILE_EDIT_FAILED,
    meta: {
      notification: {
        type: 'danger',
        titleText: _I18n.default.text('FileManagerCore.notifications.editFile.error.title'),
        message: _I18n.default.text('FileManagerCore.notifications.editFile.error.message')
      }
    }
  };
}

function updateFileMeta(fileId, data) {
  return function (dispatch, getState, httpClient) {
    dispatch(getSaveFileEditAttemptedAction());
    return FilesApi.updateFileMeta(fileId, data, httpClient).then(function (file) {
      dispatch(getSaveFileEditSuccessAction(file));
      return file;
    }, function (err) {
      dispatch(getSaveFileEditFailedAction());
      throw err;
    });
  };
}

var fetchFilesForNavigator = function fetchFilesForNavigator(_ref) {
  var type = _ref.type,
      searchQuery = _ref.searchQuery,
      selectedFolder = _ref.selectedFolder;
  return function (dispatch, getState) {
    var query = Object.assign({
      type: type
    }, (0, _network.getProviderParam)(type), {
      search: searchQuery,
      folder_id: selectedFolder ? selectedFolder.get('id') || 'None' : null,
      limit: _Constants.FETCH_FILES_LIMIT
    });
    dispatch((0, _Actions.fetchInitialFiles)(query, type));

    if (searchQuery && (0, _Configuration.getIsShutterstockEnabled)(getState())) {
      dispatch({
        type: _ActionTypes.SEARCH_SHUTTERSTOCK_RESET
      });
      dispatch((0, _Shutterstock.searchShutterstock)({
        searchQuery: searchQuery,
        page: 1,
        pageSize: _Constants.PAGE_SIZE
      }));
    }
  };
};

exports.fetchFilesForNavigator = fetchFilesForNavigator;